import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submitOnShortcut(event) {
    if (event.isComposing) return
    if (event.key !== "Enter") return
    if (!event.ctrlKey && !event.metaKey) return

    event.preventDefault()
    this.element.requestSubmit()
  }
}
